import { dateFilterModel } from "config/filterModels/dateFilterModel";
import { multipleTerminalFilterModel } from "config/filterModels/multipleTerminalFilterModel";
import { statisticStepFilterModel } from "config/filterModels/statisticStepFilterModel";
import { statisticTypeFilterModel } from "config/filterModels/statisticTypeFilterModel";
import { FilterModel } from "model/Filter.model";

export const statisticFilterConfig: FilterModel[] = [dateFilterModel, multipleTerminalFilterModel, statisticTypeFilterModel, statisticStepFilterModel];
